<template>
  <div class="learning">
    <NavHeaderBar title="学术推广" leftArrow rightArrow />
    <img
      :src="require('@/assets/img/rz1.png')"
      class="fixed"
      @click="handleJoin"
      alt="ruzhu"
    />
    <van-sticky offset-top="45px">
      <PolyvPlayer
        url="651e0bb700e809ccc69a0df382638d92_6"
        cover="https://ydkoss.usfsoft.com/fengmian/shiping/141.png"
        :osignflag="flag"
      />
    </van-sticky>
    <div class="learning-warp">
      <TimeAxis
        v-for="(item, index) in advantagelist"
        :key="index"
        :over="item.over"
      >
        <TextCard
          :title="item.title"
          :desc="item.desc"
          :content="item.content"
        />
      </TimeAxis>
    </div>
    <JoinUsContent />
    <JoinUsBar />
  </div>
</template>

<script>
import { routerPush } from "@/config/locationRouter";
export default {
  name: "JoinUs",
  data() {
    return {
      flag: false,
      advantagelist: [
        {
          over: false,
          title: "4+7带量采购",
          desc: "份额之争白热化",
          content: "中标：60%-70%份额;非中30%-40%份额，如何在其中争夺更大蛋糕？"
        },
        {
          over: false,
          title: "一致性评价",
          desc: "只有出奇制胜，才能鹤立鸡群",
          content:
            "药企市场部/医学部，作为企业的情报机构、学术机构、参谋机构和品牌机构，在行业新形势下，如何找好产品定位、快速对接学术推广平台、合规地做好学术推广、走向品牌学术营销。"
        },
        {
          over: false,
          title: "医药代表备案",
          desc: "药品推广向学术推广转型",
          content:
            "药品推广将回归其本质，真正意义上的学术推广将得到认可和支持，医药代表的门槛会快速提高，成为备受尊重的职业。"
        },
        {
          over: true,
          title: "医保支付改革",
          desc: "促进医药服务供给侧改革",
          content:
            "随着医保控费更加严厉，药品、耗材价格还会继续下降，倒逼药品生产企业努力转移到提升药品质量、促进药品研发、开展系列精准有效合规的学术推广轨道上来，逐步在相关领域形成优势和壁垒。"
        }
      ]
    };
  },
  methods: {
    handleJoin() {
      routerPush({ path: "/settledFrom" });
    }
  }
};
</script>

<style lang="scss">
.learning {
  .van-nav-bar--fixed {
    z-index: 9;
  }
  .fixed {
    width: 87px;
    height: 47px;
    position: fixed;
    right: 0;
    top: 300px;
    z-index: 2;
  }
  .learning-video {
    height: 150px;
    margin-top: 45px;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 9;
  }
  .learning-warp {
    margin-top: 45px;
    padding: 15px;
    background-color: #ffffff;
  }
}
</style>
